import { cardTitle, title, primaryColor } from 'assets/jss/material-kit-react.js'

const consultStyle = {
  section: {
    padding: '10px 0',
    textAlign: 'center',
  },
  title: {
    ...title,
    marginBottom: '2rem',
    marginTop: '30px',
    minHeight: '32px',
    textDecoration: 'none',
  },
  titleIcon: {
    marginRight: '5px',
    fontSize: '2.25rem',
  },
  itemGrid: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  cardTitle,
  cardHeader: {
    width: 'auto',
    textAlign: 'center',
    marginLeft: '20px',
    marginRight: '20px',
    marginTop: '-40px',
    padding: '20px 0',
    marginBottom: '15px',
  },
  cardFooter: {
    paddingTop: '0rem',
    border: '0',
    borderRadius: '6px',
    justifyContent: 'center !important',
  },
  cardBodyContainer: {
    textAlign: 'left',
    listStyle: 'circle',
    '& li': {
      marginBottom: '4px',
      '&:hover': {
        color: primaryColor,
        fontWeight: '500',
        marginLeft: '-10px',
        transition: 'All 0.3s ease',
      },
    },
  },
}

export default consultStyle
